module.exports = __webpack_public_path__ + "img/logo-white.f4809256.png";